<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="200px" class="searchForm">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="FPA编号" prop="fpaNo">
              <el-input v-model="queryCondition.fpaNo" clearable style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Category2" prop="category2">
              <el-select v-model="queryCondition.category2" placeholder="请选择">
                <el-option v-for="item in category2Options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Product or Commodity Purchased" prop="productOrCommodityPurchased">
              <el-input v-model="queryCondition.productOrCommodityPurchased" clearable style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="开始日期" prop="agreementStartDate" class="flexBox">
              <el-date-picker v-model="queryCondition.agreementStartDate" type="date" :placeholder="'Select Date'" value-format="yyyy-MM-dd" :picker-options="AgreementPickerOptionsStart" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结束日期" prop="agreementEndDate" class="flexBox">
              <el-date-picker v-model="queryCondition.agreementEndDate" type="date" :placeholder="'Select Date'" value-format="yyyy-MM-dd" :picker-options="AgreementPickerOptionsEnd" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否已下发" prop="isIssued">
              <el-select v-model="queryCondition.isIssued" placeholder="请选择">
                <el-option v-for="item in isIssuedOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="下发时间(从)" prop="issueTimeStart">
              <el-date-picker v-model="queryCondition.issueTimeStart" type="date" :placeholder="'Select Date'" value-format="yyyy-MM-dd" :picker-options="issueTimeStartOptions" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="下发时间(至)" prop="issueTimeEnd">
              <el-date-picker v-model="queryCondition.issueTimeEnd" type="date" :placeholder="'Select Date'" value-format="yyyy-MM-dd" :picker-options="issueTimeEndOptions" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
          <el-button size="mini" @click="restQueryFormThis" type="primary">重置</el-button>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button size="mini" class="btn" type="primary" @click="resetMdm()">重置为未下发</el-button>
      <el-button size="mini" class="btn" type="primary" @click="confirmMdm()">确定</el-button>
    </div>
    <el-table :data="tableFpaList" ref="tableFpaList" border highlight-current-row max-height='420'>
      <el-table-column align="center" width="55">
        <template slot-scope="scope">
          <el-radio v-model="selectRadio" @change="radioChange(scope.row)" :label="scope.row.ttFpaId"></el-radio>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="fpaNo" label="FPA编号" width="100">
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row)">{{scope.row.fpaNo}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="category2" label="Category2" max-width="100"></el-table-column>
      <el-table-column show-overflow-tooltip prop="productOrCommodityPurchased" label="Product or Commodity Purchased" min-width="140"></el-table-column>
      <el-table-column show-overflow-tooltip prop="agreementStartDate" label="开始日期" min-width="90"></el-table-column>
      <el-table-column show-overflow-tooltip prop="agreementEndDate" label="结束日期" min-width="90"></el-table-column>
      <el-table-column show-overflow-tooltip prop="isIssuedCN" label="是否已下发" min-width="60"></el-table-column>
      <el-table-column show-overflow-tooltip prop="issueTime" label="下发时间" min-width="90"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import DCApi from "@/api/DC/DC";

export default {
  components: { IcSelect },
  name: "",
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      queryCondition: {
        isIssued: "",
        issueTimeEnd: "",
        issueTimeStart: "",
        agreementEndDate: "",
        agreementStartDate: "",
        fpaNo: "",
        productOrCommodityPurchased: "",
        category2: "",
        pageNum: 1,
        pageSize: 15,
      },
      totalCount: 0,
      selectRadio: "",
      isIssuedOptions: [
        {
          label: "已下发",
          value: "Y"
        },
        {
          label: "未下发",
          value: "N"
        }
      ],
      category2Options: [
        {
          label: "Logistic",
          value: "logistic"
        },
        {
          label: "Planning Service",
          value: "planning-service"
        }
      ],
      tableFpaList: [],
      AgreementPickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      AgreementPickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.startDate;;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
      issueTimeStartOptions: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      issueTimeEndOptions: {
        disabledDate: time => {
          let beginTime = this.queryCondition.startDate;;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
      issueList: [],
      ttFpaId: null,
    };
  },
  mounted() {
    this.queryData(1)
  },
  methods: {
    toDetail(row) {
      const host = window.location.href.split("#")[0];
      console.log('111', host);
      var url = `${host}#/fpaPermanentDetail/${row.ttFpaId}/N`;
      console.log('url', url);
      window.open(url, '_blank')
    },
    queryData(val) {
      if (val) {
        this.queryCondition.pageNum = val
      }
      DCApi.getDataMdm(this.queryCondition).then(res => {
        this.tableFpaList = res.resultData;
        if (this.ttFpaId) {
          this.issueList = this.tableFpaList.filter(ele => {
            return ele.ttFpaId == this.ttFpaId
          })
          console.log('33333333', this.issueList);
        }
        this.totalCount = res.totalCount;
      });
    },
    //选择操作
    radioChange(row) {
      console.log('row', row);
      this.issueList = []
      this.issueList.push(row)
      this.ttFpaId = row.ttFpaId
    },
    // 查询条件重置
    restQueryFormThis() {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        isIssued: "",
        issueTimeEnd: "",
        issueTimeStart: "",
        agreementEndDate: "",
        agreementStartDate: "",
        fpaNo: "",
        productOrCommodityPurchased: "",
        category2: "",
        pageNum: 1,
        pageSize: 15,
      }
      this.queryData();
    },
    resetMdm() {
      console.log('this.issueList1', this.issueList);
      if (this.issueList.length > 0) {
        if (this.issueList[0].isIssued === 'Y') {
          this.$confirm('是否需要重置已下发状态', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            DCApi.resetMdm({
              issueList: this.issueList
            }).then(res => {
              console.log('res', res);
              if (res.code === '200') {
                this.issueList = []
                this.queryData()
                this.$message.success('操作成功！')
              }
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消重置'
            });
          });
        } else {
          this.$message.warning('无法操作，请检查FPA下发状态！')
        }
      } else {
        this.$message.warning('请选择FPA后再重置状态')
      }
    },
    confirmMdm() {
      console.log('this.issueList2', this.issueList);
      if (this.issueList.length > 0) {
        console.log('this.issueList', this.issueList[0].isIssued);
        if (this.issueList[0].isIssued !== 'Y') {
          DCApi.confirmMdm({
            issueList: this.issueList
          }).then(res => {
            if (res.code === '200') {
              this.issueList = []
              this.queryData()
              this.$message.success('操作成功!')
            }
          })
        } else {
          this.$message.warning('无法操作，请检查FPA下发状态！')
        }
      } else {
        this.$message.warning('请选择FPA后再确定')
      }
    }
  },
  extends: commonFunction
};
</script>
<style scoped  lang="scss">
.el-select {
  width: 100%;
}
</style>
<style lang="scss">
.supplierCodeDialog .email.el-form-item .el-form-item__content {
  display: flex;
}
</style>
